import AxiosUtil from '../utils/axiosUtil';

export const MolitService = (function () {
  let instance;
  // const BASE_URI = 'base service uri';

  function init() {
    return {
      vehicleInformation: async function (licensePlateNumbers, shopType) {
        const queryString = `lpns=${Array.from(licensePlateNumbers).join(',')}`;
        // shop_type이 'A'인 경우 다른 엔드포인트 사용
        const endpoint = shopType === 'A' 
          ? '/apis/molit/vehicle/informationK'
          : '/apis/molit/vehicle/information';
        return await AxiosUtil.Async.get(endpoint, queryString);
      },
    };
  }

  return {
    getInstance: function () {
      if (!instance) instance = init();
      return instance;
    },
  };
})();
